module.exports = __webpack_public_path__ + "img/no_admirers.1214edca.svg";